export default __webpack_public_path__ + "4a3ac7564db1aabca1065b2dcc03f271.svg";